<div class="confirm-card">

  <!-- Green Tick -->
<div class="check-circle">✓</div>

  <!-- Title -->
  <h2><span class="success-title"> Congratulations!</span><br><span class="title">  Your order has been placed successfully.</span></h2>

  <!-- Message -->
  <p class="message">
    Thank you for shopping with Ruralx!<br>Your order is confirmed and will be delivered soon.
  </p>

  <!-- Proceed Button -->
  <button class="proceed-btn" routerLink="/dashboard">Continue Shopping</button>

</div>
